/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { extendTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const colors = {
  brand: {
    purple: "#6A11CB",
    blue: "#2575FC",
    gold: "#FACC15",
    darkBg: "#0D1117",
    darkSurface: "#161B22",
    lightBg: "#F3F4F6",
    lightSurface: "#FFFFFF",
  },
};

const styles = {
  global: (props) => ({
    "html, body": {
      backgroundColor:
        props.colorMode === "dark"
          ? colors.brand.darkBg
          : colors.brand.lightBg,
      color: props.colorMode === "dark" ? "#E2E8F0" : "#1F2937",
      transition: "all 0.4s ease-in-out",
      fontFamily: "'Cairo', sans-serif",
    },

    // ✅ Navbar
    ".navbar-container": {
      backgroundColor:
        props.colorMode === "dark"
          ? colors.brand.darkBg
          : colors.brand.lightBg,
      color: props.colorMode === "dark" ? "#F1F5F9" : "#1F2937",
      borderBottom:
        props.colorMode === "dark"
          ? "1px solid #30363D"
          : "1px solid #E5E7EB",
      transition: "all 0.3s ease-in-out",
    },

    // ✅ Sidebar
    ".sidebar-container": {
      backgroundColor:
        props.colorMode === "dark"
          ? colors.brand.darkSurface
          : colors.brand.lightSurface,
      color: props.colorMode === "dark" ? "#E5E7EB" : "#1F2937",
      boxShadow:
        props.colorMode === "dark"
          ? "2px 0 10px rgba(0,0,0,0.6)"
          : "2px 0 10px rgba(0,0,0,0.05)",
      transition: "all 0.3s ease-in-out",
    },

    ".sidebar-header": {
      background:
        props.colorMode === "dark"
          ? "linear-gradient(90deg, #6A11CB, #2575FC)"
          : "linear-gradient(90deg, #6A11CB, #9D50BB)",
      color: "#fff",
      fontWeight: "600",
    },

    ".sidebar-item.active, .sidebar-item:hover": {
      background:
        props.colorMode === "dark"
          ? "rgba(250, 204, 21, 0.15)"
          : "rgba(106, 17, 203, 0.1)",
      color:
        props.colorMode === "dark"
          ? colors.brand.gold
          : colors.brand.purple,
      fontWeight: "600",
    },
  }),
};

const theme = extendTheme({ config, colors, styles });
export default theme;
